import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import {removeNullFields} from "../../../common/mapper";
import {HttpStatus} from "../../../common/Constants";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class IndentUnitBelumProsesDataProspek extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, {rowIndex}) => <>{rowIndex + 1}</>,
            },
        },
        {
            name: "memberName",
            label: "Nama",
        },
        {name: "noHandphone", label: "Telepon"},
        {name: "memberNIK", label: "NIK"},
        {name: "dateOfBirth", label: "Tgl. Lahir"},
        {name: "address", label: "Alamat"},
        {name: "kelurahanDTO.kelurahanname", label: "Kelurahan"},
        {name: "kecamatanDTO.kecamatanName", label: "Kecamatan"},
        {name: "provinsiDTO.provinceName", label: "Provinsi"},
        {
            name: "checked",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <input type="checkbox" checked={val} onChange={() => this.handleCheckData(rowIndex)}/>
                ),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            name: null,
            dataTable: [],
            pagination: {
              limit: 5, 
              page: 1
            }
        };
    }

    componentDidMount() {
        this.fetchData(null);
    }

    fetchData = async (name) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getIndentProspect,
            menuName: "Indent Unit - Search Data Prospek",
            setError: this.props.setError,
            args: {
                kodeCabang: this.props.kodeCabang, memberName: name
            },
        });
        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data.data,
            }));
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleCheckData = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataTable: prevValue.dataTable.map((dt, idx) => ({...dt, checked: index === idx})),
        }));
    };

    handleSearchProspek = () => {
        this.fetchData(this.state.name || null);
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Search Data Prospek"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <FlexView vAlignContent="bottom" style={{marginBottom: "15px", gap: "10px"}}>
                                <SimpleInput
                                    id="input_text_nama_prospek"
                                    name="namaProspek"
                                    label="Nama Prospek"
                                    containerclassname="flex-4"
                                    value={this.state.name || ""}
                                    onChange={({target}) =>
                                        this.setState((prevValue) => ({
                                            ...prevValue,
                                            name: target.value,
                                        }))
                                    }
                                />
                                <SimpleButton className="margin-bottom-20px" onClick={this.handleSearchProspek}>
                                    Cari
                                </SimpleButton>
                                <span className="flex-3"></span>
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.dataTable.length}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.tableColumns}
                                options={{
                                  ...defaultTableChange(
                                    this.handleChangePage,
                                    this.handleRowsPerPage,
                                  ),
                                  serverSide: false,
                                }}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                footerAdditionalButtons={
                                    <SimpleButton
                                        onClick={() => {
                                            const chosenData = this.state.dataTable.find((dt) => dt.checked);
                                            this.props.onChange(chosenData);
                                            this.props.onClickClose();
                                        }}
                                    >
                                        Pilih
                                    </SimpleButton>
                                }
                            />
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default IndentUnitBelumProsesDataProspek;
